import React from "react";
import "./App.css";
import Home from "./Home";
import { Routes, Route } from "react-router";
import AuthenticationWrapper from "./wrapper/AuthenticationWrapper";
import { SnackbarProvider, useSnackbar } from "notistack";
import { IconButton, Slide } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Spinner from "../src/components/Spinner";
import { useProfile } from "./hooks/useProfile";

function App() {
  const Transition = (props) => <Slide {...props} direction="left" />;

  const { isLoading: userInfoLoading } = useProfile();

  const SnackbarCloseButton = ({ snackbarKey }) => {
    const { closeSnackbar } = useSnackbar();
    return (
      <IconButton onClick={() => closeSnackbar(snackbarKey)}>
        <CloseIcon style={{ color: "white" }} />
      </IconButton>
    );
  };

  return (
    <SnackbarProvider
      className="operations-snackbar"
      maxSnack={1}
      TransitionComponent={Transition}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      action={(snackbarKey) => (
        <SnackbarCloseButton snackbarKey={snackbarKey} />
      )}
      autoHideDuration={10000}
    >
      <Spinner />
      <AuthenticationWrapper userInfoLoading={userInfoLoading}>
        <Routes>
          <Route path="/" element={<Home />}></Route>
        </Routes>
      </AuthenticationWrapper>
    </SnackbarProvider>
  );
}

export default App;
